import type {IModuloBase} from "../../../root/modulo";
import {ModuloContactWork} from "./module";
import {ESelector} from "./auxiliares";

class ModuloContactWorkBuilder {
    /* STATIC */
    public static async build(cfg: IModuloBase): Promise<ModuloContactWork[]> {
        return [
            new ModuloContactWork({
                ...cfg,
                id: "contact.work",
                selector:  ESelector.CONTACT_WORK,
            }),
        ];
    }
}

export default ModuloContactWorkBuilder;
